<template>
  <div id="app">
    <transition :name="$tkHistory.transition" v-if="env === 'app'">
      <tk-history>
        <router-view></router-view>
      </tk-history>
    </transition>
    <router-view v-else></router-view>
    <tk-global :components="components"></tk-global>
  </div>
</template>

<script>
  import config from './configs'
  export default {
    name: 'app',
    data () {
      let components = config.env === 'app' ? [
        {
          name: 'toast',
          component: 'tk-toast'
        }
      ] : [
        {
          name: 'alert',
          component: 'snackbar'
        },
        {
          name: 'confirm',
          component: 'confirm'
        }
      ]
      return {
        components: components,
        env: config.env
      }
    }
  }
</script>

<style>
  #app {
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue